/* ============================================================
   MAGNIX Moon Lamp — shared interactions for all sections.
   One delegated handler set; safe to load once. Guarded so it
   never binds twice even if the file is referenced more than once.
   ============================================================ */
(function () {
  if (window.__mxLampInit) return;
  window.__mxLampInit = true;

  function toggle(item, bodySel) {
    var body = item.querySelector(bodySel);
    var open = item.classList.toggle('open');
    if (body) body.style.maxHeight = open ? body.scrollHeight + 'px' : 0;
  }

  // Mirror the chosen variant + current price into the floating sticky cart
  function syncSticky(hero) {
    var sticky = hero.querySelector('.mx-sticky');
    if (!sticky) return;
    var active = hero.querySelector('.variant.active');
    var img = sticky.querySelector('.ms-img');
    var varEl = sticky.querySelector('.ms-var');
    var priceEl = sticky.querySelector('.ms-price');
    var mainPrice = hero.querySelector('.price-row .price');
    if (active) {
      if (img && active.getAttribute('data-image')) img.src = active.getAttribute('data-image');
      if (varEl && active.getAttribute('data-title')) varEl.textContent = active.getAttribute('data-title');
    }
    if (priceEl && mainPrice) priceEl.textContent = mainPrice.textContent;
  }

  document.addEventListener('click', function (e) {
    // Product accordions (hero)
    var accHead = e.target.closest('.mx-hero .acc-head');
    if (accHead) { toggle(accHead.parentElement, '.acc-body'); return; }

    // FAQ
    var faqQ = e.target.closest('.mx-faq .q');
    if (faqQ) { toggle(faqQ.parentElement, '.a'); return; }

    // Cart drawer: close
    if (e.target.closest('.mx-cd-close, .mx-cd-overlay')) { closeDrawer(); return; }
    // Cart drawer: quantity + remove
    var inc = e.target.closest('.mx-cd-inc');
    if (inc) { changeLine(inc.getAttribute('data-key'), (parseInt(inc.getAttribute('data-qty'), 10) || 1) + 1); return; }
    var dec = e.target.closest('.mx-cd-dec');
    if (dec) { changeLine(dec.getAttribute('data-key'), Math.max(0, (parseInt(dec.getAttribute('data-qty'), 10) || 1) - 1)); return; }
    var rem = e.target.closest('.mx-cd-remove');
    if (rem) { changeLine(rem.getAttribute('data-key'), 0); return; }
    // Cart links (header icon, etc.) open the drawer instead of navigating
    if (document.querySelector('.mx-cd-root')) {
      var link = e.target.closest('a[href]');
      if (link && !link.classList.contains('mx-cd-viewcart') && !link.classList.contains('mx-cd-checkout')) {
        var path = '';
        try { path = new URL(link.href, location.origin).pathname.replace(/\/+$/, ''); } catch (err) {}
        if (path === '/cart' || /\/cart$/.test(path)) { e.preventDefault(); loadCart().then(openDrawer); return; }
      }
      var bubble = e.target.closest('#cart-icon-bubble, .header__icon--cart');
      if (bubble) { e.preventDefault(); loadCart().then(openDrawer); return; }
    }

    // Sticky cart "Add to Cart" -> submit the real product form
    var msAtc = e.target.closest('.mx-sticky .ms-atc');
    if (msAtc) {
      var heroS = msAtc.closest('.mx-hero');
      var realAtc = heroS && heroS.querySelector('form .atc');
      if (realAtc) realAtc.click();
      return;
    }

    // Bundle selector (hero)
    var bopt = e.target.closest('.mx-hero .bundle-opt');
    if (bopt) {
      var bform = bopt.closest('form');
      bopt.parentElement.querySelectorAll('.bundle-opt').forEach(function (x) { x.classList.remove('active'); });
      bopt.classList.add('active');
      var qtyInput = bform && bform.querySelector('.mx-qty');
      if (qtyInput) qtyInput.value = bopt.getAttribute('data-qty') || '1';
      var heroBox = bopt.closest('.mx-hero');
      var priceEl = heroBox && heroBox.querySelector('.price-row .price');
      var oldEl = heroBox && heroBox.querySelector('.price-row .price-old');
      var saveEl = heroBox && heroBox.querySelector('.price-row .save');
      var money = bopt.getAttribute('data-money');
      var dOld = bopt.getAttribute('data-old');
      var dSave = bopt.getAttribute('data-save');
      if (priceEl && money) priceEl.textContent = money;
      if (oldEl) { if (dOld) { oldEl.textContent = dOld; oldEl.hidden = false; } else { oldEl.hidden = true; } }
      if (saveEl) { if (dSave) { saveEl.textContent = 'Save ' + dSave + '%'; saveEl.hidden = false; } else { saveEl.hidden = true; } }
      var bvars = heroBox && heroBox.querySelector('.bundle-vars');
      if (bvars) bvars.hidden = bopt.getAttribute('data-qty') !== '2';
      if (heroBox) syncSticky(heroBox);
      return;
    }

    // Variant pills (hero)
    var pill = e.target.closest('.mx-hero .variant');
    if (pill) {
      var wrap = pill.parentElement;
      wrap.querySelectorAll('.variant').forEach(function (x) { x.classList.remove('active'); });
      pill.classList.add('active');
      var hidden = pill.closest('form') && pill.closest('form').querySelector('input[name="id"]');
      if (hidden && pill.dataset.id) hidden.value = pill.dataset.id;
      var heroV = pill.closest('.mx-hero');
      if (heroV) syncSticky(heroV);
      return;
    }

    // Hero gallery video: play button
    var gplay = e.target.closest('.mx-hero .g-play');
    if (gplay) {
      var vslide = gplay.closest('.g-vslide');
      var vid = vslide && vslide.querySelector('video');
      if (vid) { vslide.classList.add('playing'); vid.setAttribute('controls', 'controls'); var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); }
      return;
    }

    // Gallery thumbnails (hero) -> scroll the image slider to that slide
    var thumb = e.target.closest('.mx-hero .thumbs .t');
    if (thumb) {
      var gallery = thumb.closest('.mx-hero');
      var track = gallery && gallery.querySelector('.g-track');
      var slides = track ? track.querySelectorAll('.g-slide') : [];
      var ti = parseInt(thumb.getAttribute('data-i'), 10) || 0;
      if (track && slides[ti]) track.scrollTo({ left: slides[ti].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      thumb.parentElement.querySelectorAll('.t').forEach(function (x) { x.classList.remove('active'); });
      thumb.classList.add('active');
      return;
    }

    // Feature carousel arrows
    var arrow = e.target.closest('.mx-fc-arrow');
    if (arrow) {
      var carA = arrow.closest('.mx-fc');
      var trackA = carA && carA.querySelector('.mx-fc-track');
      if (trackA) {
        var firstCard = trackA.querySelector('.mx-fc-card');
        var step = firstCard ? firstCard.getBoundingClientRect().width + 22 : trackA.clientWidth * 0.8;
        trackA.scrollBy({ left: arrow.classList.contains('prev') ? -step : step, behavior: 'smooth' });
      }
      return;
    }

    // Feature carousel dots
    var dot = e.target.closest('.mx-fc-dot');
    if (dot) {
      var carD = dot.closest('.mx-fc');
      var trackD = carD && carD.querySelector('.mx-fc-track');
      var cards = trackD ? trackD.querySelectorAll('.mx-fc-card') : [];
      var i = parseInt(dot.getAttribute('data-i'), 10) || 0;
      if (cards[i]) trackD.scrollTo({ left: cards[i].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
      return;
    }
  });

  // Keep carousel dots in sync while scrolling / swiping
  function initCarousels(root) {
    (root || document).querySelectorAll('.mx-fc').forEach(function (car) {
      if (car.__mxc) return;
      var track = car.querySelector('.mx-fc-track');
      if (!track) return;
      car.__mxc = true;
      var dots = car.querySelectorAll('.mx-fc-dot');
      function update() {
        if (!dots.length) return;
        var cards = track.querySelectorAll('.mx-fc-card');
        var pos = track.scrollLeft, best = 0, bestd = Infinity, base = cards[0] ? cards[0].offsetLeft : 0;
        cards.forEach(function (cd, idx) {
          var d = Math.abs((cd.offsetLeft - base) - pos);
          if (d < bestd) { bestd = d; best = idx; }
        });
        dots.forEach(function (dt, idx) { dt.classList.toggle('active', idx === best); });
      }
      var raf;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); });
      update();
    });
  }
  if (document.readyState !== 'loading') initCarousels();
  else document.addEventListener('DOMContentLoaded', function () { initCarousels(); });
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });

  /* ---------- Cart drawer ---------- */
  function formatMoney(cents, fmt) {
    fmt = fmt || '${{amount}}';
    function commas(n) { var p = n.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return p.join('.'); }
    var amount = commas((cents / 100).toFixed(2));
    var amountNo = commas((cents / 100).toFixed(0));
    var amountComma = commas((cents / 100).toFixed(2)).replace(/,/g, ' ').replace('.', ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNo)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNo.replace(/,/g, ' '));
  }

  function openDrawer() {
    document.querySelectorAll('.mx-cd-root').forEach(function (r) { r.classList.add('open'); });
    var a = document.querySelector('.mx-cd'); if (a) a.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    document.querySelectorAll('.mx-cd-root').forEach(function (r) { r.classList.remove('open'); });
    var a = document.querySelector('.mx-cd'); if (a) a.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function renderCart(cart) {
    document.querySelectorAll('.mx-cd-root').forEach(function (root) {
      var wrap = root.querySelector('.mx-cd-items');
      var empty = root.querySelector('.mx-cd-empty');
      var sub = root.querySelector('.mx-cd-sub');
      var fmt = root.getAttribute('data-money-format');
      if (!cart || !cart.items || !cart.items.length) {
        if (empty) empty.style.display = 'block';
        if (wrap) wrap.innerHTML = '';
      } else {
        if (empty) empty.style.display = 'none';
        if (wrap) wrap.innerHTML = cart.items.map(function (it) {
          var img = it.image ? it.image.replace(/(\.(?:png|jpg|jpeg|webp|gif))(\?.*)?$/i, '_120x$1$2') : '';
          var v = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="ci-var">' + it.variant_title + '</div>' : '';
          return '<div class="mx-cd-item" data-key="' + it.key + '">' +
            (img ? '<img src="' + img + '" alt="" width="62" height="62">' : '<div class="ci-mid-img"></div>') +
            '<div class="ci-mid"><div class="ci-title">' + it.product_title + '</div>' + v +
            '<div class="ci-qty">' +
            '<button class="mx-cd-dec" data-key="' + it.key + '" data-qty="' + it.quantity + '" aria-label="Decrease">&minus;</button>' +
            '<span class="qn">' + it.quantity + '</span>' +
            '<button class="mx-cd-inc" data-key="' + it.key + '" data-qty="' + it.quantity + '" aria-label="Increase">+</button>' +
            '<button class="mx-cd-remove" data-key="' + it.key + '">Remove</button>' +
            '</div></div>' +
            '<div class="ci-price">' + formatMoney(it.final_line_price, fmt) + '</div>' +
            '</div>';
        }).join('');
      }
      if (sub) sub.innerHTML = formatMoney(cart ? cart.total_price : 0, fmt);
    });
    // cart quantity badge (Dawn's .cart-count-bubble, restyled as a circle)
    var count = cart ? cart.item_count : 0;
    document.querySelectorAll('#cart-icon-bubble, .header__icon--cart').forEach(function (link) {
      var bubble = link.querySelector('.cart-count-bubble');
      if (count > 0) {
        if (!bubble) { bubble = document.createElement('div'); bubble.className = 'cart-count-bubble'; link.appendChild(bubble); }
        bubble.innerHTML = '<span aria-hidden="true">' + (count > 99 ? '99+' : count) + '</span>';
      } else if (bubble) {
        bubble.parentNode.removeChild(bubble);
      }
    });
  }

  function loadCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function buildItems(hero, form) {
    var qtyInput = form.querySelector('.mx-qty');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var idInput = form.querySelector('input[name="id"]');
    var curId = idInput ? idInput.value : null;
    if (qty >= 2) {
      var bv = hero.querySelector('.bundle-vars');
      if (bv && !bv.hidden) {
        var s1 = bv.querySelector('.bv-1'), s2 = bv.querySelector('.bv-2');
        var out = [];
        if (s1 && s1.value) out.push({ id: s1.value, quantity: 1 });
        if (s2 && s2.value) out.push({ id: s2.value, quantity: 1 });
        if (out.length) return out;
      }
      return [{ id: curId, quantity: qty }];
    }
    return [{ id: curId, quantity: 1 }];
  }

  // Intercept the product form so Add to Cart uses the drawer (not a page reload)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.mx-hero form');
    if (!form) return;
    if (!document.querySelector('.mx-cd-root')) return; // no drawer installed -> let it post normally
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;
    e.preventDefault();
    var hero = form.closest('.mx-hero');
    var btn = form.querySelector('.atc');
    if (btn) btn.setAttribute('disabled', 'disabled');
    addItems(buildItems(hero, form))
      .then(function () { return loadCart(); })
      .then(function () { openDrawer(); })
      .catch(function () {})
      .then(function () { if (btn) btn.removeAttribute('disabled'); });
  });

  // Open the first product accordion in each hero on load
  function openFirst() {
    document.querySelectorAll('.mx-hero .acc-item.open .acc-body').forEach(function (b) {
      b.style.maxHeight = b.scrollHeight + 'px';
    });
  }

  // Reveal the floating sticky cart once the main Add-to-Cart is scrolled past
  function initSticky() {
    document.querySelectorAll('.mx-hero').forEach(function (hero) {
      if (hero.__mxSticky) return;
      var atc = hero.querySelector('form .atc');
      var sticky = hero.querySelector('.mx-sticky');
      if (!atc || !sticky) return;
      hero.__mxSticky = true;
      syncSticky(hero);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            // show only when the button is above the viewport (scrolled past), not before reaching it
            var past = !en.isIntersecting && en.boundingClientRect.top < 0;
            sticky.classList.toggle('show', past);
          });
        }, { threshold: 0 }).observe(atc);
      }
    });
  }

  // Keep thumbnails in sync while swiping the image slider
  function initGallery() {
    document.querySelectorAll('.mx-hero .g-track').forEach(function (track) {
      if (track.__mxg) return;
      track.__mxg = true;
      var hero = track.closest('.mx-hero');
      var thumbs = hero ? hero.querySelectorAll('.thumbs .t') : [];
      var slides = track.querySelectorAll('.g-slide');
      function update() {
        if (!slides.length) return;
        var base = slides[0].offsetLeft, pos = track.scrollLeft, best = 0, bestd = Infinity;
        slides.forEach(function (s, i) { var d = Math.abs((s.offsetLeft - base) - pos); if (d < bestd) { bestd = d; best = i; } });
        slides.forEach(function (s, i) {
          s.classList.toggle('active', i === best);
          // pause videos we scrolled away from, but let looping (autoplay) videos keep running
          if (i !== best) { var v = s.querySelector && s.querySelector('video'); if (v && !v.paused && !v.loop) v.pause(); }
        });
        thumbs.forEach(function (t, i) { t.classList.toggle('active', i === best); });
      }
      var raf;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); });

      // Desktop: match the vertical thumbnail column height to the main image
      var thumbsEl = hero ? hero.querySelector('.thumbs') : null;
      var mainEl = hero ? hero.querySelector('.g-main') : null;
      function fitThumbs() {
        if (!thumbsEl || !mainEl) return;
        if (window.matchMedia('(min-width:861px)').matches) { thumbsEl.style.maxHeight = mainEl.offsetHeight + 'px'; }
        else { thumbsEl.style.maxHeight = ''; }
      }
      fitThumbs();
      window.addEventListener('resize', fitThumbs);
      window.addEventListener('load', fitThumbs);
      if (mainEl) { var im = mainEl.querySelector('img,video'); if (im) im.addEventListener('load', fitThumbs); }
    });
  }

  function initAll() {
    openFirst();
    initSticky();
    initGallery();
    if (document.querySelector('.mx-cd-root') || document.querySelector('#cart-icon-bubble')) loadCart();
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function () { initAll(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
})();